import type { Session } from '@customerio/hydra-session-state';

// Account name for an id from session metadata, which tracks same-bundle workspace switches (unlike auth.account).
export function findAccountName(sessions: Session[], accountId: number | undefined): string | undefined {
  if (accountId == null) {
    return undefined;
  }

  for (const session of sessions) {
    const match = session.accounts?.find((account) => account.account_id === accountId);
    if (match != null) {
      return match.account_name;
    }
    if (session.home_account_id === accountId) {
      return session.name;
    }
  }

  return undefined;
}
